export default {
  // 認証
  login: {
    en: 'Login',
    ja: 'ログイン',
  },
  logout: {
    en: 'Logout',
    ja: 'ログアウト',
  },
  username: {
    en: 'Username',
    ja: 'ユーザー名',
  },
  password: {
    en: 'Password',
    ja: 'パスワード',
  },

  // バリデーションメッセージ
  usernameRequired: {
    en: 'Please enter your username',
    ja: 'ユーザー名を入力してください',
  },
  passwordRequired: {
    en: 'Please enter your password',
    ja: 'パスワードを入力してください',
  },

  // エラーメッセージ
  invalidCredentials: {
    en: 'Invalid username or password',
    ja: 'ユーザー名またはパスワードが無効です',
  },
  sessionExpired: {
    en: 'Your session has expired. Please log in again.',
    ja: 'セッションの有効期限が切れました。再度ログインしてください。',
  },
  unauthorized: {
    en: 'You are not authorized to view this page.',
    ja: 'このページを表示する権限がありません。',
  },

  // ステータスメッセージ
  loggingIn: {
    en: 'Logging in...',
    ja: 'ログイン中...',
  },
  loggingOut: {
    en: 'Logging out...',
    ja: 'ログアウト中...',
  },
  loginSuccess: {
    en: 'Login successful',
    ja: 'ログインに成功しました',
  },
  logoutSuccess: {
    en: 'Logged out successfully',
    ja: 'ログアウトしました',
  },
};
